function normalizeList(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (value && typeof value === 'object') {
    return Object.values(value);
  }
  return [];
}

function normalizePlatforms(payload) {
  const candidates = [payload?.platforms, payload?.items, payload?.data, payload];

  for (const candidate of candidates) {
    const list = normalizeList(candidate);
    if (list.length === 0) {
      continue;
    }

    const rows = list
      .filter((item) => item && typeof item === 'object')
      .map((item, index) => {
        const platform = String(item.platform || item.value || `platform-${index}`).trim();
        const label = String(item.label || platform).trim() || platform;
        const alias = String(item.alias || '').trim();

        return {
          platform,
          label,
          alias,
          draftAlias: alias,
        };
      })
      .filter((item) => item.platform);

    if (rows.length > 0) {
      return rows;
    }
  }

  return [];
}

export function mapTradingPlatformAliasesResponseToDto(payload) {
  return normalizePlatforms(payload);
}

export function buildTradingPlatformAliasesPayload(rows, changedPlatform, changedAlias) {
  return rows.map((row) => ({
    platform: row.platform,
    alias:
      row.platform === changedPlatform
        ? (String(changedAlias || '').trim() || null)
        : (String(row.alias || '').trim() || null),
  }));
}

